import styled from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { site } from '@panel/commons/helpers';

const SubWrapper = styled.div`
  padding: 40px 40px 45px;
  white-space: normal;
  ${withQuery.xs.down()} {
    padding: 0px 0px 80px;
    margin: 0px 16px;
  }
  > form > fieldset {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ModuleTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  padding: 0px 0px 30px;
  word-wrap: break-word;
  ${withQuery.md.down()} {
    width: auto;
  }
  ${withQuery.xs.down()} {
    font-weight: 400;
    font-size: 18px;
    padding: 28px 0px;
  }
`;

const OperationTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 288px;
  > div {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  ${withQuery.xs.down()} {
    width: 100%;
  }
`;

const OperationTypeChoice = styled.div`
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  border-top: 1px solid ${select('midDarkGray')};
  border-bottom: 1px solid ${select('midDarkGray')};
  background-color: ${props => !props.disabled && props.checked && `${getColor('primary')}}`};
  ${props =>
    props.disabled &&
    `background-color: ${site.isMexico ? select('middleGray') : select('lightGray')};
  `}
  + div {
    border-left-width: 0;
  }

  :first-child {
    border-left: 1px solid ${select('midDarkGray')};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    label {
      border-left: none;
    }
  }

  :last-child {
    border-right: 1px solid ${select('midDarkGray')};
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  input + label {
    color: ${select('darkGray')};
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    border-left: 1px solid ${select('midLightGray')};
    cursor: pointer;
    width: 100%;
    ${withQuery.xs.down()} {
      flex: 1;
      width: 100%;
    }
    :checked {
      background-color: ${getColor('primary')};
    }
  }

  input:checked + label {
    cursor: pointer;
    position: relative;
    z-index: 1;
    background-color: ${getColor('primary')};
    color: #fff;
    text-shadow: 0 0 0.6px #fff, 0 0 0.6px #fff, 0 0 0.6px #fff;
    border-left: ${props => !props.disabled && 'none'};
  }

  input:disabled + label {
    cursor: auto;
    background-color: ${site.isMexico ? select('middleGray') : select('lightGray')};
    color: ${site.isMexico ? select('darkGray') : select('midLightGray')};
  }

  :hover input + label {
    border-left: ${props => !props.disabled && 'none'};
  }

  :hover + div input + label {
    border-left: ${props => !props.disabled && 'none'};
  }

  :focus + div input + label {
    border-left: none;
  }

  + div input + label {
    border-left: ${props => props.checked && !props.disabled && 'none'};
  }

  :hover {
    background-color: ${props => !props.checked && !props.disabled && `${select('middleGray')}`};
    cursor: ${props => !props.checked && !props.disabled && 'pointer'};
  }
`;

const OperationTypeRadio = styled.input`
  opacity: 0;
  position: fixed;
  width: 0;
`;

const PropertyTypeWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  width: 100%;
  max-width: 640px;
  > div:not(:first-child) {
    margin-left: 30px;
  }
  ${withQuery.md.down()} {
    flex-direction: column;
    > div:not(:first-child) {
      margin-left: 0px;
    }
  }
`;

const SelectWrapper = styled.div`
  width: 100%;
  max-width: 270px;
  ${withQuery.xs.down()} {
    margin-bottom: 8px;
    max-width: none;
  }
`;

const SelectLabel = styled.label(props => ({
  color: select('black'),
  display: 'block',
  margin: '10px 0px 6px'
}));

const Select = styled.select`
  font-size: 14px;
  width: 100%;
  height: 48px;
  padding: 12px;
  border: 1px solid ${select('midDarkGray')};
  border-radius: 8px;
  outline: none;
  background-color: transparent;
  -webkit-appearance: none;
  :hover {
    cursor: pointer;
  }
  :nth-child(4) {
    margin-left: 32px;
  }
  :disabled {
    background-color: ${select('lightGray')};
    border-color: transparent;
    color: ${select('midLightGray')};
    cursor: default;
  }
`;

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  top: -32px;
  right: 16px;
  float: right;
  pointer-events: none;
`;

const Option = styled.option`
  background-color: ${select('lightGray')};
`;

const ErrorMessage = styled.span`
  color: ${select('negative')};
  display: inherit;
  padding: 7px 0px 0px 15px;
  font-size: 12px;
  min-height: 25px;
`;

export {
  SubWrapper,
  ModuleTitle,
  OperationTypeWrapper,
  OperationTypeChoice,
  OperationTypeRadio,
  PropertyTypeWrapper,
  SelectWrapper,
  SelectLabel,
  Select,
  IconWrapper,
  Option,
  ErrorMessage
};
